import { createPatch } from 'rfc6902';
import { uuidv7 } from 'uuidv7';
import { zql } from '../../schema.js';
import { EventLogs } from '../../utils.js';
import { addEventLog, EventLogResources } from '../util.js';
import { isSequenceDoctorValidated } from '../../util/patients-therapies.js';
import { logAmmsMfnChangeForSequence } from './add-therapy-parameter.js';
export async function removePatientProtocol(tx, input, userId) {
    const now = Date.now();
    const patientProtocol = await tx.run(zql.patientProtocols.where('id', '=', input.patientProtocolId).where('deletedAt', 'IS', null).one());
    if (!patientProtocol)
        throw new Error('Not Found');
    const characteristics = await tx.run(zql.patientCharacteristics
        .related('patient')
        .where('patientId', '=', patientProtocol.patientId)
        .orderBy('createdAt', 'desc')
        .limit(1)
        .one());
    const sequences = await tx.run(zql.patientTherapySequence
        .related('medicine', medicine => medicine.where('deletedAt', 'IS', null))
        .where('patientProtocolId', '=', input.patientProtocolId)
        .where('deletedAt', 'IS', null));
    if (sequences.some(seq => !seq.isNote && isSequenceDoctorValidated(seq))) {
        throw new Error('A protocol with doctor-validated prescriptions cannot be removed. Stop it instead.');
    }
    // Before the medicines are soft-deleted, so each MFN MDL still carries its ZDRs.
    await Promise.all(sequences.map(seq => logAmmsMfnChangeForSequence(tx, { sequenceId: seq.id, change: 'delete', now })));
    const sequenceOps = [];
    const logSequenceOps = [];
    for (const seq of sequences) {
        sequenceOps.push(() => tx.mutate.patientTherapySequence.update({ id: seq.id, deletedAt: now, deletedBy: userId }));
        for (const med of seq.medicine) {
            sequenceOps.push(() => tx.mutate.patientTherapySequenceMedicine.update({ id: med.id, deletedAt: now, deletedBy: userId }));
        }
        if (tx.location === 'server') {
            const patches = createPatch(seq, { ...seq, deletedAt: now, deletedBy: userId });
            logSequenceOps.push(() => addEventLog(tx, {
                id: uuidv7(),
                resource: EventLogResources.patientTherapySequence,
                resourceId: seq.id,
                action: 'delete',
                domain: 'prescription',
                event: EventLogs.PATIENT_THERAPY_SEQUENCE_PROTOCOL_DELETED,
                patches,
                performedBy: userId,
                performedAt: now,
                details: {
                    id: seq.internalId,
                    patientId: patientProtocol.patientId,
                    patientName: characteristics?.patient?.fullName ?? '',
                    reason: input.reason,
                },
            }));
        }
    }
    sequenceOps.push(() => tx.mutate.patientProtocols.update({ id: input.patientProtocolId, deletedAt: now, deletedBy: userId }));
    await Promise.all(sequenceOps.map(op => op()));
    await Promise.all(logSequenceOps.map(op => op()));
}
//# sourceMappingURL=remove-patient-protocol.js.map